import { render, staticRenderFns } from "./initiate.vue?vue&type=template&id=1ba4955c&scoped=true"
import script from "./initiate.vue?vue&type=script&lang=js"
export * from "./initiate.vue?vue&type=script&lang=js"
import style0 from "./initiate.vue?vue&type=style&index=0&id=1ba4955c&prod&lang=scss"
import style1 from "./initiate.vue?vue&type=style&index=1&id=1ba4955c&prod&lang=scss"
import style2 from "./initiate.vue?vue&type=style&index=2&id=1ba4955c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba4955c",
  null
  
)

export default component.exports